import * as Yup from 'yup';

export const validationSchemaSocailMedia = new Yup.ObjectSchema({
    password:Yup.string().required('Cannot be empty').min(6,'SocailMedia should be atleast 6 character long'),
    passwordConfirm: Yup.string().required('Cannot be empty').oneOf([Yup.ref('password'), null], 'SocailMedias must match'),
});

export const initialValuesSocailMedia = {
   facebook:'',
   instagram:'',
   linkedIn:'',
   twitter:'',
   website:'',
}

export const feildsSocailMedia = [
    {
        name:'facebook',
        placeholder:'Enter facebook profile url',
        id:'facebook',
        type:'text',
        label:'Facebook'
    },
    {
        name:'instagram',
        placeholder:'Enter instagram profile url',
        id:'instagram',
        type:'text',
        label:'Instagram'
    },
    {
        name:'linkedin',
        placeholder:'Enter linkedin profile url',
        id:'linkedin',
        type:'text',
        label:'Linked In'
    },
    {
        name:'twitter',
        placeholder:'Enter twitter profile url',
        id:'twitter',
        type:'text',
        label:'Twitter'
    },
    {
        name:'webiste',
        placeholder:'Enter your website url',
        id:'website',
        type:'text',
        label:'Website'
    },
];